import React from 'react';
import { Link } from 'react-router-dom';
import { HiHome } from 'react-icons/hi2';

function Details({ product }) {
  if (!product) return null;

  // استخراج هوشمندانه و ایمن نام دسته‌بندی برای جلوگیری از نمایش ID (مثل عدد ۱۲)
  const getCategoryName = () => {
    if (!product.category && !product.category_name) return 'دسته‌بندی‌ها';
    
    // اگر آبجکت کامل با فیلد name یا title فرستاده شده باشه
    if (typeof product.category === 'object' && product.category !== null) {
      return product.category.name || product.category.title || 'دسته‌بندی';
    }
    
    // اگر فیلد مجزایی به اسم category_name در ریسپانس وجود داشته باشه
    if (product.category_name) {
      return product.category_name;
    }
    
    // اگر استرینگ باشه
    return String(product.category);
  };

  const categoryName = getCategoryName();
  const categoryParam = typeof product.category === 'object' && product.category !== null 
    ? (product.category.slug || product.category.id || categoryName)
    : product.category;

  const breadcrumbItems = [
    { label: 'خانه', href: '/', icon: true },
    { label: 'محصولات', href: '/products' },
    { label: categoryName, href: `/products?category=${categoryParam}` },
    { label: product.name || 'جزئیات محصول' },
  ];

  return (
    <div className="mx-auto my-3 w-[95%] max-w-7xl" dir="rtl">
      {/* کانتینر اصلی با پس‌زمینه سبز زیتونی، شادو و انیمیشن ملایم */}
      <nav 
        aria-label="Breadcrumb"
        className="flex flex-wrap items-center gap-x-1.5 gap-y-1.5 rounded-xl sm:rounded-2xl bg-[#82906f] px-3.5 py-2.5 sm:px-5 sm:py-3 shadow-[0_4px_20px_rgba(130,144,111,0.25)] border border-[#96a582]/40 backdrop-blur-sm"
      >
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;

          return (
            <React.Fragment key={index}>
              {isLast ? (
                /* آیتم فعال / آخرین مرحله (نام محصول) با فونت ریسپانسیو و مدیریت طول متن */
                <span 
                  title={item.label}
                  className="max-w-[130px] sm:max-w-[220px] md:max-w-[340px] lg:max-w-[480px] truncate font-bold text-[#f2f6ee] text-[11px] sm:text-xs md:text-sm drop-shadow-sm"
                >
                  {item.label}
                </span>
              ) : (
                /* لینک‌های مراحل قبلی - بدون text-decoration */
                <Link
                  to={item.href}
                  className="group flex items-center gap-1 font-medium text-white/80 transition-all duration-200 hover:text-white hover:scale-[1.02] text-[11px] sm:text-xs md:text-sm whitespace-nowrap no-underline"
                >
                  {item.icon && (
                    <HiHome className="text-xs sm:text-sm opacity-80 group-hover:opacity-100 transition-opacity" />
                  )}
                  <span className="no-underline">{item.label}</span>
                </Link>
              )}

              {/* آیکون جداکننده شیک و مینیمال */}
              {!isLast && (
                <span className="select-none text-white/40 text-[10px] sm:text-xs md:text-sm font-light px-0.5">
                  /
                </span>
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </div>
  );
}

export default Details;